/**
 * Pure calendar event predicates (join gating, read-only lock).
 */

export function isClinicalNoteLockedStatus(status: string | undefined): boolean {
  return status === 'signed' || status === 'cosigned';
}

export function viewerIsCalendarEventParticipant(
  event: {
    practitionerId?: string;
    ownerPractitionerId?: string;
    patientId?: string;
    additionalParticipants?: Array<{ resourceType: string; id: string }>;
  },
  viewer: { practitionerId?: string; patientId?: string },
): boolean {
  if (viewer.practitionerId) {
    if (event.practitionerId === viewer.practitionerId) return true;
    if (event.ownerPractitionerId === viewer.practitionerId) return true;
    if (
      event.additionalParticipants?.some(
        (p) => p.resourceType === 'Practitioner' && p.id === viewer.practitionerId,
      )
    ) {
      return true;
    }
  }
  if (viewer.patientId) {
    if (event.patientId === viewer.patientId) return true;
    if (
      event.additionalParticipants?.some(
        (p) => p.resourceType === 'Patient' && p.id === viewer.patientId,
      )
    ) {
      return true;
    }
  }
  return false;
}

export function actorRefIsAppointmentParticipant(
  participants: Array<{ actor?: { reference?: string } }> | undefined,
  actorRef: string | undefined,
): boolean {
  if (!actorRef) return false;
  return (participants ?? []).some((p) => p.actor?.reference === actorRef);
}

export function isCalendarEventReadOnly(event: {
  canManage?: boolean;
  isInvitedEvent?: boolean;
  linkedNoteSigned?: boolean;
} | null | undefined): boolean {
  if (!event) return false;
  if (event.linkedNoteSigned) return true;
  if (event.canManage === false) return true;
  if (event.canManage === true) return false;
  return Boolean(event.isInvitedEvent);
}

export function calendarEventReadOnlyMessage(event: {
  linkedNoteSigned?: boolean;
} | null | undefined): string {
  if (event?.linkedNoteSigned) {
    return 'This appointment is locked because the linked clinical note is signed.';
  }
  return 'You do not have permission to change this calendar item.';
}

export function shouldShowCalendarJoin(input: {
  isTelehealthOrHybrid: boolean;
  isParticipant: boolean;
  /** Join URL already stored on the appointment. */
  hasVideoMeeting: boolean;
}): boolean {
  return input.isTelehealthOrHybrid && input.isParticipant && input.hasVideoMeeting;
}

/** Open session on telehealth is Join; keep it for in-person tools or meeting participants. */
export function shouldShowAppointmentOpenSession(input: {
  isInPerson: boolean;
  isParticipant: boolean;
}): boolean {
  return input.isInPerson || input.isParticipant;
}
